import { asType } from '@sparky/framework'
import { ActivationManifest, PrimaryAppIds } from '../renderer'
import { CSP_LEARN_MORE_LINK, DAS_BANNER_MESSAGE, IOT_PACKAGE_1, IOT_PACKAGE_2, IOT_APP_ID, IOT_3P_ADDON_APP_ID } from '../constants'

const cdlSection = {
  key: 'activation-accordion-cdl',
  component: 'activation.UAccordion',
  props: {
    title: 'Strata Logging Service',
    children: [
      {
        key: 'default-cdl-component',
        component: 'activation.UCDL',
        props: {
          enableMigration: true,
          isUnifiedDisplay: true,
          title: 'Add Strata Logging Service',
          cdlDropDownProps: {
            display: {
              errorMessage: 'Select SLS to proceed activation',
              subTitle: 'SLS instance for this tenant'
            },
            dropDownProps: {
              required: false,
              triggerValidationOnChange: true,
            },
            size: {
              height: 32,
              width: 300
            },
            passByProps: {
              dataTestId: 'cdl-activation-screen',
              enableSearch: true,
              label: 'Strata Logging Service',
              placeholder: 'Select SLS Instance',
            }
          }
        }
      },
    ]
  }
}
const addOnSection = {
  key: 'activation-accordion-addons',
  component: 'activation.UAccordion',
  props: {
    title: 'Add one',
    children: [
      {
        key: 'default-add-on-field',
        component: 'activation.DefaultAddonField',
        props: {
          isUnified: true
        }
      }
    ]
  }
}
const subdomainSection = {
  key: 'activation-accordion-subdomain',
  component: 'activation.UAccordion',
  props: {
    title: 'Subdomain',
    children: [
      {
        key: 'default-sub-domain-field',
        component: 'activation.SubDomainField',
        props: {
        }
      }
    ]
  }
}
const bannerSection = {
  key: 'activation-banner',
  component: 'activation.ActivationBanner',
  props: {
    group: 1,
    appearance: 'standard',
    type: 'inline',
    infoMessage: DAS_BANNER_MESSAGE,
  }
}
export default asType<ActivationManifest>({
  activation_id: IOT_APP_ID,
  description: 'IoT Security',
  primary_app_id: PrimaryAppIds.ZINGBOX,
  flags: {
    hash_required: true,
    cdl_required: true, // default set to true and handle code level for 2.0
    sub_domain_required: true,
    has_license_packages: true,
    lock_existing_cdl_qty: true,
    extra: { ua_enabled: true }, // TODO: Temporary flag for QA verification, to be removed once UA is fully rolled out
    addons: [{
      app_id: IOT_3P_ADDON_APP_ID,
      display_name: 'IoT Third party addon',
      licenseTypeTitle: 'Plan',
      required_x_signature: true,
      autoActivate: true, //  activation form will automatically adds into 'set' form fields,
      licenseTypeEnums: {
        'IOTBASIC': 'Basic',
        'IOTADV': 'Advanced',
        'IOTADVEVAL': 'Advanced',
        'IOTADVEVAL60': 'Advanced',
        'RENIOTADV': 'Advanced',
        'IOTADVTRIAL': 'Advanced',
      }
    }],
  },
  extra: {
    [IOT_PACKAGE_1]: [
      addOnSection,
      cdlSection,
      subdomainSection,
      bannerSection
    ],
    [IOT_PACKAGE_2]: [
      addOnSection,
      subdomainSection,
      bannerSection
    ],
    [IOT_3P_ADDON_APP_ID]: [
      addOnSection
    ]
  },
  activation_screens: [
    {
      key: 'activate',
      component: 'activation.UDefaultActivationScreen',
      props: {
        title: '',
        description: '',
        primaryButton: {
          text: 'Activate Now',
        },
        children: [
          {
            key: 'screen-header',
            component: 'activation.UScreenHeader',
            props: {
              title: 'Activate IoT Security',
              headerAppId: PrimaryAppIds.ZINGBOX,
              showDeviceLicense: true
            }
          },
          {
            key: 'activation-form',
            component: 'activation.UDefaultActivationForm',
            props: {
              title: '',
              subTitle: '',
              children: [
                {
                  key: 'ela-header',
                  component: 'activation.ElaLicenseInfo',
                  props: {
                    'is_unified': true
                  }
                },
                {
                  key: 'activation-section-csp',
                  component: 'activation.UActivationSection',
                  props: {
                    title: 'Select Customer Support Account',
                    subtitle: 'This account is used for the registration and support of the products and add-ons that are bundled with this subscription.',
                    link: CSP_LEARN_MORE_LINK,
                    children: [
                      {
                        key: 'activation-accordion-csp',
                        component: 'activation.UAccordion',
                        props: {
                          title: 'Customer Support Account:',
                          children: [
                            {
                              key: 'default-dropdown-component-csp',
                              component: 'activation.UCSPComponent',
                              props: {
                              },
                            },
                          ]
                        }
                      },
                      {
                        key: 'activation-section-subscription',
                        component: 'activation.UActivationSection',
                        props: {
                          title: 'Allocate This Product',
                          children: [
                            {
                              key: 'activation-accordion-tsg',
                              component: 'activation.UAccordion',
                              props: {
                                title: 'Recipient:',
                                children: [
                                  {
                                    key: 'default-tsg-component',
                                    component: 'activation.UTSGComponent',
                                    props: {
                                    }
                                  },
                                ]
                              }
                            },
                            {
                              key: 'activation-accordion-region',
                              component: 'activation.UAccordion',
                              props: {
                                title: 'Region:',
                                children: [
                                  {
                                    key: 'default-region-component',
                                    component: 'activation.URegionComponent',
                                    props: {
                                    }
                                  },
                                ]
                              }
                            },
                          ]
                        }
                      },
                    ]
                  }
                },
                {
                  key: 'form-footer',
                  component: 'activation.FormFooter',
                  props: {
                    group: 3,
                    buttonText: 'Activate',
                    dataTestId: 'activate-button'
                  }
                }
              ],
            }
          },
          {
            key: 'screen-footer',
            component: 'activation.ScreenFooter',
            props: {
            }
          }
        ],
      }
    }
  ],
})
